import { render, staticRenderFns } from "./StaffHome.vue?vue&type=template&id=64f38234&scoped=true&"
import script from "./StaffHome.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StaffHome.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./StaffHome.vue?vue&type=style&index=0&id=64f38234&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f38234",
  null
  
)

export default component.exports